module.exports = __webpack_public_path__ + "img/godo_pc_03.4e020406.png";